import PurchaseOrders from "../../../purchases/PurchaseOrders.jsx";
export default function PlaceOrder(props) {
  return <PurchaseOrders {...props} />;
}
